// Названия 23 направлений на трёх языках — КОПИЯ из данных профтеста.
//
// Источник один: src/data/careers_1822_{ru,az,en}.json, теми же словами ребёнок
// читал свой результат. Здесь только названия, потому что анкета и отчёт
// зарубежного модуля рисуются в браузере, а тянуть туда три файла профтеста
// целиком (все профессии с описаниями) ради 23 строк — лишний вес.
//
// КОПИЯ СТЕРЕЖЁТСЯ: scripts/verify-edu-programs.mts сверяет её с данными
// профтеста буква в букву. Поправили название в профтесте — сборка упадёт,
// пока копия не обновлена. Правят название ТАМ, не здесь.

import type { ProgramClusterId } from "./programs";

export type DirectionLang = "ru" | "az" | "en";

export const DIRECTION_NAMES: Record<ProgramClusterId, Record<DirectionLang, string>> = {
  finance: { ru: "Финансы и экономика", az: "Maliyyə və iqtisadiyyat", en: "Finance & economy" },
  business: { ru: "Бизнес и управление", az: "Biznes və idarəetmə", en: "Business & management" },
  procurement: { ru: "Закупки и логистика", az: "Tədarük və logistika", en: "Procurement & logistics" },
  marketing: { ru: "Маркетинг и реклама", az: "Marketinq və reklam", en: "Marketing & advertising" },
  sales: { ru: "Продажи и переговоры", az: "Satış və danışıqlar", en: "Sales & negotiations" },
  hr: { ru: "HR и управление людьми", az: "İnsan resursları və idarəetmə", en: "HR & people management" },
  technology: { ru: "Технологии и IT", az: "Texnologiya və IT", en: "Technology & IT" },
  design: { ru: "Дизайн и творческие профессии", az: "Dizayn və yaradıcı peşələr", en: "Design & creative professions" },
  media: { ru: "Медиа, журналистика и коммуникации", az: "Media, jurnalistika və kommunikasiyalar", en: "Media, journalism & communications" },
  education: { ru: "Образование и развитие", az: "Təhsil və inkişaf", en: "Education & development" },
  healthcare: { ru: "Медицина и здравоохранение", az: "Tibb və səhiyyə", en: "Medicine & healthcare" },
  law: { ru: "Право и юриспруденция", az: "Hüquq və ədliyyə", en: "Law & justice" },
  engineering: { ru: "Инженерия и производство", az: "Mühəndislik və istehsal", en: "Engineering & manufacturing" },
  trades_technical: { ru: "Ремёсла и техника", az: "Sənətkarlıq və texnika", en: "Trades & Technical" },
  science: { ru: "Наука и исследования", az: "Elm və tədqiqatlar", en: "Science & research" },
  government: { ru: "Государственное управление и дипломатия", az: "Dövlət idarəçiliyi və diplomatiya", en: "Government & diplomacy" },
  hospitality: { ru: "Гостеприимство и туризм", az: "Qonaqpərvərlik və turizm", en: "Hospitality & tourism" },
  environment: { ru: "Экология и устойчивое развитие", az: "Ekologiya və davamlı inkişaf", en: "Ecology & sustainable development" },
  social: { ru: "Социальная работа и НКО", az: "Sosial iş və QHT-lər", en: "Social work & nonprofits" },
  agriculture: { ru: "Агробизнес и пищевая промышленность", az: "Aqrobiznes və qida sənayesi", en: "Agribusiness & food industry" },
  sports_beauty: { ru: "Спорт, красота и здоровый образ жизни", az: "İdman, gözəllik və sağlam həyat tərzi", en: "Sports, beauty & healthy lifestyle" },
  real_estate: { ru: "Недвижимость и строительство", az: "Daşınmaz əmlak və tikinti", en: "Real estate & construction" },
  creative_arts: { ru: "Искусство и культура", az: "İncəsənət və mədəniyyət", en: "Arts & culture" },
};

/** Название направления. Незнакомый код — сам код: пропасть он не должен. */
export function directionName(id: string, lang: DirectionLang = "ru"): string {
  return (DIRECTION_NAMES as Record<string, Record<DirectionLang, string>>)[id]?.[lang] ?? id;
}
